"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerYearSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _DatePickerYearSelectorStyled = require("../styled/DatePickerYearSelectorStyled");
const DatePickerYearSelector = _ref => {
  let {
    locale,
    maxDate,
    minDate,
    onChange,
    selectedYear
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const userProvidedMinYear = minDate?.year ?? null;
  const userProvidedMaxYear = maxDate?.year ?? null;
  const allYears = (0, _react.useMemo)(() => getYearOptions(selectedYear, userProvidedMinYear, userProvidedMaxYear), [selectedYear, userProvidedMinYear, userProvidedMaxYear]);
  return /*#__PURE__*/_react.default.createElement(_DatePickerYearSelectorStyled.DatePickerYearSelectorStyled, {
    options: allYears,
    onChange: value => {
      if (value === undefined || value === null || value.year === selectedYear) {
        // This won't really happen since this select isn't clearable.
        return;
      }
      onChange(value.year);
    },
    selectedOption: allYears.find(option => option.year === selectedYear) || null,
    getOptionKey: option => option.year,
    optionToString: option => option?.year.toString() || "",
    locale: locale,
    isClearable: false,
    themeMode: themeMode
  });
};
exports.DatePickerYearSelector = DatePickerYearSelector;
const DEFAULT_MIN_YEARS = 15;
const DEFAULT_MAX_YEARS = 15;
const getYearOptions = (selectedYear, providedStart, providedEnd) => {
  const start = providedStart ?? selectedYear - DEFAULT_MIN_YEARS;
  const end = providedEnd ?? selectedYear + DEFAULT_MAX_YEARS;
  return Array.from({
    length: end - start + 1
  }).fill(1).map((_, index) => {
    const year = start + index;
    return {
      year
    };
  });
};
//# sourceMappingURL=DatePickerYearSelector.js.map